<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div class="page-container gray-200">
  <div class="content-band width-full">
    <div class="inline-text-field-container flex-row gap-20 pb-20">
      <div class="pt-20 pb-20">
        System Name:
        <b>{{ systemName }}</b>
      </div>
      <div class="inline-text-field-container application-name min-w400">
        <div class="inline-select select-container chevron border-bottom border-gray-600">
          <div class="select-container chevron border-bottom border-gray-600">
            <select class="ds-select-field rounded-4 hover-gray-300" [(ngModel)]="applicationKey"
              (ngModelChange)="onChangeApplicationDropdown($event)">
              @for (app of currentApplication; track app) {
                <option [value]="app.applicationKey">
                  {{ app.applicationName }}
                </option>
              }
            </select>
            @if (systemApplications?.Applications?.length !== 1) {
              <label class="ds-floating-label">Application
              Name</label>
            }
          </div>
        </div>
      </div>
      <div class="basis-50"></div>
    </div>
    <div class="flex-row">
      <div>
        Your Current Relevant Role(s):
        <ul class="roles display-inline-block">
          @for (userRoles of userRoleObj?.userRoles; track userRoles; let i = $index) {
            <li>
              {{ userRoles?.roleName }}
              @if (i < userRoleObj?.userRoles?.length - 1) {
                <span>,&nbsp;</span>
              }
            </li>
          }
        </ul>
      </div>
      <div class="flex-row pb-20 pr-40">
        <div class="card fluid">
          <div class="card__content">
            <div class="overflow-scroll">
              <div class="tabs">
                <div class="flex" role="tablist" aria-label="Tabs testing">
                  <button (click)="renderTab($event)" class="" role="tab"
                    [attr.aria-selected]="isSelected == 'summary-tab'" aria-controls="summary-tab" id="summary-tab">
                    My Summary View
                  </button>
                  <button (click)="renderTab($event)" class="" role="tab"
                    [attr.aria-selected]="isSelected == 'details-tab'" aria-controls="details-tab" id="details-tab"
                    tabindex="0">
                    My Details View
                  </button>
                  <button (click)="renderTab($event)" class="" role="tab"
                    [attr.aria-selected]="isSelected == 'compare-summary'" aria-controls="compare-summary"
                    id="compare-summary" tabindex="0">
                    Compare Roles Summary View
                  </button>
                  <button (click)="renderTab($event)" class="" role="tab"
                    [attr.aria-selected]="isSelected == 'compare-details'" aria-controls="compare-details"
                    id="compare-details" tabindex="0">
                    Compare Roles Details View
                  </button>
                </div>

                <div class="tabpanel-container fade">
                  @if (isSelected == 'summary-tab') {
                    <div class="container p-40" tabindex="0" role="tabpanel" id="summary-tab"
                      aria-labelledby="summary-tab">
                      <app-my-summary-view [dataLst]="summaryTabData"></app-my-summary-view>
                    </div>
                  }

                  @if (isSelected == 'details-tab') {
                    <div class="container p-40" tabindex="0" role="tabpanel" id="details-tab"
                      aria-labelledby="details-tab">
                      <ul id="MySummaryViewUL" class="summary-view">
                        @for (item of mydetailsview; track item) {
                          <li>
                            {{ item.entitlementName }}
                          </li>
                        }
                      </ul>
                    </div>
                  }

                  @if (isSelected == 'compare-summary') {
                    <div class="container p-10" tabindex="0" role="tabpanel" id="compare-summary"
                      aria-labelledby="compare-summary">
                      <app-compare-roles-summary-view [dataRoleInternal]="internalSummarRoles"
                        [dataRoleExternal]="externalSummarRoles">
                      </app-compare-roles-summary-view>
                    </div>
                  }
                  @if (isSelected == 'compare-details') {
                    <div class="container p-10" tabindex="0" role="tabpanel" id="compare-details"
                      aria-labelledby="compare-details">
                      <app-compare-roles-details [applicationKey]="applicationKey"></app-compare-roles-details>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <tabset class="MyNav">
  <tab heading="My Summary View" id="mysummary" customClass="customClass" (selectTab)="onSelect($event)">
    <app-my-summary-view [dataLst]="SummaryTabData"></app-my-summary-view>
  </tab>

  <tab heading="My Details View" id="mydetails" (selectTab)="onSelect($event)">
    <ul id="MySummaryViewUL">
      <li *ngFor="let item of mydetailsview">
        {{ item.entitlementName }}
      </li>
    </ul>
  </tab>
  <tab heading="Compare Roles Summary View" id="myRolesSummaryView">
    <app-compare-roles-summary-view [dataRoleInternal]="internalSummarRoles" [dataRoleExternal]="externalSummarRoles">
    </app-compare-roles-summary-view>
  </tab>

  <tab heading="Compare Roles Details View" id="compareRoles" (selectTab)="onSelect($event)">
    <app-compare-roles-details [applicationName]="applicationName"></app-compare-roles-details>
  </tab>
</tabset> -->
</div>
